import { Nullable } from '~types/Nullable';

// Root key for all Tread Agent durable resources (conversation list + individual
// conversations). TreadAgentStore invalidates this prefix when a streamed turn completes so
// the list and the open conversation refetch their persisted state, and invalidates the
// 'conversation'/'conversations' child prefixes alone when a conversation is retitled mid-turn.
// Keep the child keys in each query hook rooted here so a single prefix invalidation reaches
// all of them.
export const TREAD_AGENT_QUERY_KEY = 'treadAgent';

export const treadAgentConversationQueryKey = (
  companyId: Nullable<string>,
  conversationId: Nullable<string>,
) => [TREAD_AGENT_QUERY_KEY, 'conversation', companyId, conversationId];

// Deliberately NOT under TREAD_AGENT_QUERY_KEY: that prefix is invalidated wholesale after
// every completed turn, which would refetch a list that rarely changes.
export const TREAD_AGENT_SKILLS_QUERY_KEY = 'treadAgentSkills';
